import { Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { SearchKeyFilter } from '../../app/AppUtils';
import ContentLoader from '../subcomponents/ContentLoader';
import FilterButton from '../subcomponents/FilterButton';
import FilterSidebar from '../subcomponents/FilterSidebar';
import PageLayout from '../subcomponents/PageLayout';
import ContactCard from './ContactCard';
import { fetchContacts } from './contactSlice';

export default function ContactPage() {
    const dispatch = useDispatch();

    const { contacts } = useSelector((state) => state.contacts);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { student } = useSelector((state) => state.student);
    const { siomSettings } = useSelector((state) => state.settings.siom);

    const [filter, setFilter] = useState("");
    const [mentor, setMentor] = useState(siomSettings.mentorAsContact);

    useEffect(() => {
        if (student !== null) {
            dispatch(fetchContacts(student?.userId));
        };
    }, [dispatch, student]);

    const mentorClick = () => {
        setMentor(!mentor);
    };

    const handleFilterResult = (item) => {
        return SearchKeyFilter(item, ["firstname", "insertion", "lastname", "email", "phone"], filter) && item.isMentor === mentor && (!mentor ? item.isContact === true : item.isContact === true || item.isContact === false);
    }

    const FilterFragment = () => {
        return (
            <>
                {siomSettings.mentorAsContact &&
                    <FormGroup sx={{ width: 1 }}>
                        <FormControlLabel sx={{ alignSelf: 'center' }} control={<Checkbox checked={mentor} onChange={mentorClick} />} label={`${resourceFinal[appLanguage].messages.SHOW_MENTOR}`} />
                    </FormGroup>
                }
            </>
        );
    };

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.CONTACT}
            content={
                <ContentLoader
                    successCondition={contacts.status === "success"}
                    errorCondition={contacts.status === "failed"}
                    content={
                        <>
                            <Grid container spacing={1} justifyContent="center">
                                {contacts.status === "success" ?
                                    contacts.data.filter(handleFilterResult).length > 0 ? contacts.data.filter(handleFilterResult).map((item) =>
                                        <Grid key={item.id} size={{ xs: 12, md: 4 }}>
                                            <ContactCard contact={item} />
                                        </Grid>
                                    ) : <Grid size={{ xs: "grow" }}><Typography variant="h6" textAlign="center">{resourceFinal[appLanguage].messages.FILTER_RESULT_EMPTY}</Typography></Grid> : ""}
                            </Grid>
                        </>
                    }
                />
            } contentLeft={
                <FilterSidebar enableSearch searchFilter={filter} searchFilterSet={setFilter} filters={<FilterFragment />} />
            } contentBottom={
                siomSettings.mentorAsContact ? <FilterButton filters={<FilterFragment />} /> : ""
            }
            bottomBar
            enableSearch
            searchFilter={filter}
            searchFilterSet={setFilter}
            disableContentBackground
        />
    );
}
